var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FallBack',{attrs:{"message":_vm.message,"border":false,"iconStyle":"far","icon":"at"}}),_c('div',{staticClass:"modal-button-container"},[_c('BaseButton',{attrs:{"color":"blue","width":"280"},on:{"onClick":_vm.handleContinue}},[_vm._v("Continue")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }